export default function Loading() {
  return <div style={{ color: 'rgba(255,255,255,.4)' }}>Loading...</div>;
}
